module.exports = __webpack_public_path__ + "img/chuzhou.877b2729.png";